module.exports = __webpack_public_path__ + "static/media/sponsor.5c64c0ba.png";